import * as React from 'react';
import { getStore } from '../../Redux/store.provider';
import { bindActionCreators } from 'redux';
import { CommonBaseStore, CommonStore } from 'sos-common/js/commonTypes/commonStore.types';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { dialogueErrorBody, dialogueErrorButton, TIMEOUT_TYPE } from 'sos-eservice-common/js/config';
import { ESERVICE_MENU_SAVE_CLOSE } from '../../components/EServiceFormMenu/eservicemenu.actions';
import { saveCloseAction } from '../EServiceFormMenu/eservicemenu.actions';

export interface FormDialogueErrorProps {}

export interface FormDialogueErrorState {
  errorIndex: number;
  isModalOpen: boolean;
  dialogueErrorBody: dialogueErrorBody;
}

export class FormDialogueError extends React.Component<FormDialogueErrorProps, FormDialogueErrorState> {
  private _store: CommonStore;
  private _saveAndClose: any;

  constructor(props: FormDialogueErrorProps) {
    super(props);

    this.state = {
      errorIndex: 0,
      isModalOpen: false,
      dialogueErrorBody: null,
    };
  }

  componentDidMount() {
    getStore((store) => {
      this._store = store;
      this._saveAndClose = bindActionCreators(saveCloseAction, store.dispatch);
      this._store.subscribe(this.onStoreUpdate);
      this.onStoreUpdate();
    });
  }

  onStoreUpdate = () => {
    const state: CommonBaseStore = this._store.getState();
    const { errors } = state;
    let dialogueErrorBodies = errors && (errors['dialogueErrorBodies'] as dialogueErrorBody[]);

    if (dialogueErrorBodies && dialogueErrorBodies.length > this.state.errorIndex) {
      this.setState((prevState) => {
        return {
          errorIndex: prevState.errorIndex + 1,
          isModalOpen: true,
          dialogueErrorBody: dialogueErrorBodies[dialogueErrorBodies.length - 1],
        };
      });
    }
  };

  closeConfirm = () => {
    const { dialogueErrorBody } = this.state;
    if (dialogueErrorBody.type === TIMEOUT_TYPE) {
      let redirectBtn = dialogueErrorBody.buttons.find((x) => x.redirectUrl != '');
      if (redirectBtn !== undefined) {
        window.location.href = redirectBtn.redirectUrl;
      } else {
        console.warn('No redirect link found. Closing modal with no further actions.');
      }
    }
    this.setState({
      isModalOpen: false,
    });
  };

  doAction = (redirectUrl: string, action: string) => {
    this.closeConfirm();
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }

    if (action === ESERVICE_MENU_SAVE_CLOSE) {
      this._saveAndClose();
    }
  };

  mapButtons = (btn: dialogueErrorButton) => {
    return (
      <button
        key={btn.text + Date.now().toString()}
        onClick={(_) => this.doAction(btn.redirectUrl, btn.action)}
        className={btn.cssClassNames}>
        {btn.text}
      </button>
    );
  };

  public render() {
    const { isModalOpen, dialogueErrorBody } = this.state;

    return (
      <Dialog isOpen={isModalOpen} onRequestClose={this.closeConfirm}>
        <button onClick={this.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>

        {dialogueErrorBody && (
          <React.Fragment>
            {dialogueErrorBody.body}
            <div className="footer">{dialogueErrorBody.buttons.map(this.mapButtons)}</div>
          </React.Fragment>
        )}
      </Dialog>
    );
  }
}
